(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[990],{

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(27192);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 6 modules
var ButtonBase = __webpack_require__(82607);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/BreadcrumbCollapsed.js








const BreadcrumbCollapsedButton = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(({
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': (0,esm_extends/* default */.Z)({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': (0,esm_extends/* default */.Z)({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = (0,styled/* default */.ZP)(MoreHoriz)({
  width: 24,
  height: 16
});
/**
 * @ignore - internal component.
 */

function BreadcrumbCollapsed(props) {
  const ownerState = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedButton, (0,esm_extends/* default */.Z)({
      focusRipple: true
    }, props, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedIcon, {
        ownerState: ownerState
      })
    }))
  });
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = (BreadcrumbCollapsed);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(28979);
// EXTERNAL MODULE: ./node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(76087);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/breadcrumbsClasses.js

function getBreadcrumbsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0,generateUtilityClasses/* default */.Z)('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
/* harmony default export */ var Breadcrumbs_breadcrumbsClasses = (breadcrumbsClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js


const _excluded = ["children", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];













const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return (0,composeClasses/* default */.Z)(slots, getBreadcrumbsUtilityClass, classes);
};

const BreadcrumbsRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${Breadcrumbs_breadcrumbsClasses.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = (0,styled/* default */.ZP)('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = (0,styled/* default */.ZP)('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});

function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

const Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });

  const {
    children,
    className,
    component = 'nav',
    expandText = 'Show path',
    itemsAfterCollapse = 1,
    itemsBeforeCollapse = 1,
    maxItems = 8,
    separator = '/'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const [expanded, setExpanded] = react.useState(false);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });

  const classes = useUtilityClasses(ownerState);
  const listRef = react.useRef(null);

  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.

      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };

  const allItems = react.Children.toArray(children).filter(child => {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

/***/ }),

/***/ 16167:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-tinh-huong/thi-thu/[slug]",
      function () {
        return __webpack_require__(50227);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ AppDownload; },
/* harmony export */   "Z": function() { return /* binding */ AppSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50122);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65907);
/* eslint-disable no-unreachable */ /* eslint-disable react/prop-types */ 



function AppSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "row",
        my: 1,
        p: 1,
        spacing: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/tai-app/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        src: "/icons/qr.jpg",
                        sx: {
                            cursor: "pointer"
                        },
                        alt: "tải app"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: "/icons/ic_ios.jpg",
                                alt: "ios"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: "/icons/ic_android.jpg",
                                alt: "android"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function AppDownload() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: {
                    mb: 3
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                variant: "subtitle1",
                children: "Tải App di động v\xe0 chia sẻ"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                my: 2,
                spacing: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/icons/qr.jpg",
                            alt: "",
                            sx: {
                                width: 50,
                                height: 60,
                                cursor: "pointer"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/icons/ic_ios.jpg",
                            alt: "",
                            sx: {
                                width: 120,
                                height: 50,
                                cursor: "pointer"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/tai-app/",
                        target: "_blank",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/icons/ic_android.jpg",
                            alt: "",
                            sx: {
                                width: 130,
                                height: 50,
                                cursor: "pointer"
                            }
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 11566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AudioPlayer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.min.js
var plyr_min = __webpack_require__(21443);
var plyr_min_default = /*#__PURE__*/__webpack_require__.n(plyr_min);
// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.css
var plyr = __webpack_require__(5667);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./src/utils/axios.js
var axios = __webpack_require__(92369);
;// CONCATENATED MODULE: ./src/service/gplx.speech.service.js




var synthesizeTextToSpeech = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(text, gender) {
        var config, resp, audioBlob;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    config = {
                        url: "/texttospeech/synthesize",
                        method: "POST",
                        data: {
                            text: text,
                            gender: gender
                        },
                        responseType: "arraybuffer"
                    };
                    return [
                        4,
                        (0,axios/* handleRequest */.X)(config)
                    ];
                case 1:
                    resp = _state.sent();
                    if ((0,_instanceof/* default */.Z)(resp, ArrayBuffer)) {
                        audioBlob = new Blob([
                            resp
                        ], {
                            type: "audio/mp3"
                        });
                        return [
                            2,
                            URL.createObjectURL(audioBlob)
                        ];
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function synthesizeTextToSpeech(text, gender) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/AudioPlayer.js
/* eslint-disable react/prop-types */ 







var AudioPlayer = function(param) {
    var text = param.text, _index = param.index, index = _index === void 0 ? "" : _index;
    var ref = (0,react.useState)("male"), voiceName = ref[0], setVoiceName = ref[1];
    var playerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var player = new (plyr_min_default())("#player-".concat(index), {
            speed: {
                selected: 1,
                options: [
                    0.25,
                    0.5,
                    1,
                    1.25,
                    1.5
                ]
            }
        });
        playerRef.current = player;
        player.on("play", function() {
            if (!player.source) fetchAudio(voiceName);
        });
        return function() {
            player.destroy();
        };
    }, [
        text,
        index
    ]);
    var fetchAudio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(voiceName) {
            var audioUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            synthesizeTextToSpeech(text, voiceName)
                        ];
                    case 1:
                        audioUrl = _state.sent();
                        if (audioUrl) {
                            playerRef.current.source = {
                                type: "audio",
                                sources: [
                                    {
                                        src: audioUrl,
                                        type: "audio/mp3"
                                    }
                                ]
                            };
                            playerRef.current.play();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchAudio(voiceName) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeVoice = function(name) {
        if (name !== voiceName) {
            setVoiceName(name);
            fetchAudio(name);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                my: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "male",
                        src: "/img/male.jpg",
                        onClick: function() {
                            return changeVoice("male");
                        },
                        sx: {
                            border: voiceName === "male" ? "2px solid blue" : "none",
                            cursor: "pointer",
                            width: 30,
                            height: 30
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "female",
                        src: "/img/female.jpg",
                        onClick: function() {
                            return changeVoice("female");
                        },
                        sx: {
                            border: voiceName === "female" ? "2px solid blue" : "none",
                            width: 30,
                            height: 30,
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                        id: "player-".concat(index),
                        className: "plyr",
                        controls: true,
                        children: "Your browser does not support the audio element."
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_AudioPlayer = (AudioPlayer);


/***/ }),

/***/ 28075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ GoogleBannerAds; },
/* harmony export */   "a": function() { return /* binding */ GoogleGridAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function GoogleBannerAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "1281160371",
        "data-ad-format": "auto",
        "data-full-width-responsive": "true"
    });
}
function GoogleGridAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-format": "autorelaxed",
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "6470023398"
    });
}


/***/ }),

/***/ 991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.js





// next

// @mui

// ----------------------------------------------------------------------
Breadcrumbs_Breadcrumbs.propTypes = {
    activeLast: (prop_types_default()).bool,
    links: (prop_types_default()).array.isRequired
};
function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                marginBottom: 5
            },
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                textTransform: "inherit",
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        }),
        style: {
            alignItems: "center"
        }
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
// ----------------------------------------------------------------------
LinkItem.propTypes = {
    link: prop_types_default().shape({
        href: (prop_types_default()).string,
        icon: (prop_types_default()).any,
        name: (prop_types_default()).string
    })
};
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "grey.600",
                "& > div": {
                    display: "inherit"
                }
            },
            textTransform: "inherit",
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.js





// @mui

//



// ----------------------------------------------------------------------
HeaderBreadcrumbs.propTypes = {
    links: (prop_types_default()).array,
    subtitle: (prop_types_default()).node,
    heading: (prop_types_default()).string.isRequired,
    moreLink: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]),
    sx: (prop_types_default()).object
};
function HeaderBreadcrumbs(_param) {
    var links = _param.links, subtitle = _param.subtitle, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "subtitle",
        "heading",
        "moreLink",
        "sx"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({}, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                        links: links
                    }, other)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    justifyContent: "flex-start"
                                },
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "fa-solid:arrow-left"
                                }),
                                onClick: function() {
                                    return router.back();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "h1",
                                textTransform: "uppercase",
                                children: heading
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0,
                            pl: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: subtitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 50227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SituationExam; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/HeaderBreadcrumbs.js + 1 modules
var HeaderBreadcrumbs = __webpack_require__(991);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.comment.js
var blog_comment = __webpack_require__(29050);
// EXTERNAL MODULE: ./src/redux/slices/gplx.exam.slice.js
var gplx_exam_slice = __webpack_require__(3955);
// EXTERNAL MODULE: ./src/routes/paths.js
var paths = __webpack_require__(76939);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(19267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(72882);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(68509);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(53252);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/components/AppSection.js
var AppSection = __webpack_require__(27941);
// EXTERNAL MODULE: ./src/components/AudioPlayer.js + 1 modules
var AudioPlayer = __webpack_require__(11566);
// EXTERNAL MODULE: ./src/components/FBSocial.js
var FBSocial = __webpack_require__(36239);
// EXTERNAL MODULE: ./src/components/GoogleAds.js
var GoogleAds = __webpack_require__(28075);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
// EXTERNAL MODULE: ./src/components/Markdown.js
var Markdown = __webpack_require__(81320);
// EXTERNAL MODULE: ./src/sections/comment/CommentList.js
var CommentList = __webpack_require__(16634);
// EXTERNAL MODULE: ./src/sections/comment/CommentNewForm.js
var CommentNewForm = __webpack_require__(79136);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video.es.js
var video_es = __webpack_require__(85215);
// EXTERNAL MODULE: ./node_modules/videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels.js
var videojs_contrib_quality_levels = __webpack_require__(78984);
// EXTERNAL MODULE: ./node_modules/videojs-http-source-selector/dist/videojs-http-source-selector.es.js
var videojs_http_source_selector_es = __webpack_require__(85258);
// EXTERNAL MODULE: ./node_modules/videojs-youtube/dist/Youtube.js
var Youtube = __webpack_require__(72575);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(33726);
// EXTERNAL MODULE: ./src/redux/slices/gplx.failSituation.slice.js
var gplx_failSituation_slice = __webpack_require__(55530);
// EXTERNAL MODULE: ./src/redux/slices/gplx.situation.slice.js
var gplx_situation_slice = __webpack_require__(10765);
;// CONCATENATED MODULE: ./src/sections/situationExam/ExamPlayerPreview.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 












// ----------------------------------------------------------------------
function ExamPlayerPreview() {
    var playerRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }), exam = ref.exam, examSituation = ref.examSituation, hint = ref.hint;
    (0,react.useEffect)(function() {
        if (!playerRef.current) {
            var options = {
                playbackRates: [
                    0.5,
                    1,
                    1.5,
                    2
                ],
                fluid: true,
                fill: true,
                responsive: true,
                controls: true,
                preload: "auto",
                autoplay: true,
                muted: false,
                aspectRatio: "16:9",
                enableDocumentPictureInPicture: true,
                controlBar: {
                    remainingTimeDisplay: false,
                    currentTimeDisplay: true,
                    pictureInPictureToggle: false,
                    playbackRateMenuButton: false,
                    timeDivider: true,
                    durationDisplay: true,
                    playToggle: true,
                    volumePanel: true
                },
                userActions: {
                    hotkeys: function hotkeys(event) {
                        // `this` is the player in this context
                        event.preventDefault();
                        if (event.target.type === "button") {
                            event.target.blur();
                        }
                        if (event.which === 32) {
                            spaceFnc(event);
                            return false;
                        }
                        return true;
                    }
                },
                inactivityTimeout: 0,
                plugins: {
                    httpSourceSelector: {
                        default: "auto"
                    }
                },
                html5: {
                    vhs: {
                        overrideNative: true
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false
                }
            };
            var player = playerRef.current = (0,video_es["default"])("video_1", options);
            player.controlBar.progressControl.disable();
            player.controlBar.playToggle.disable();
            video_es["default"].log.level("off");
            player.playsinline(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        return function() {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [
        playerRef
    ]);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        if (!player.ended()) if (hint) player.pause();
        else player.play();
    }, [
        hint
    ]);
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        //only play when new video
        if (examSituation && !examSituation.isAnswered && (exam === null || exam === void 0 ? void 0 : exam.status) === "Đang thi") {
            var id = examSituation.situation.id;
            player.poster("".concat(config/* BASEURL */.Hc, "/stream/video/").concat(examSituation.situation.id, "/thumbnail/thumb.jpg"));
            player.src({
                src: "".concat(config/* BASEURL */.Hc, "/stream/video/").concat(id, "/index.m3u8"),
                type: "application/x-mpegURL"
            });
            drawNavigateBar(player);
        }
        if ((exam === null || exam === void 0 ? void 0 : exam.status) === "Đang thi") {
            player.on("ended", onNextVideo);
            return function() {
                player.off("ended", onNextVideo);
            };
        }
        return function() {
            try {
                var ref;
                player === null || player === void 0 ? void 0 : (ref = player.controlBar) === null || ref === void 0 ? void 0 : ref.removeChild("Component");
            } catch (e) {
                console.log();
            }
        };
    }, [
        examSituation,
        exam
    ]);
    var onNextVideo = function() {
        var st = exam.examSituations.find(function(item) {
            return item.orderNo === examSituation.orderNo + 1;
        });
        if (st) dispatch((0,gplx_exam_slice/* setExamSituation */.C_)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, st), {
            isAnswered: false
        })));
        else {
            var ex = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, exam), {
                status: "Kết th\xfac"
            });
            dispatch((0,gplx_exam_slice/* setExam */.NI)(ex));
            dispatch((0,gplx_exam_slice/* addExams */.Qv)(ex));
        }
        try {
            var ref, ref1;
            (ref = playerRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.controlBar) === null || ref1 === void 0 ? void 0 : ref1.removeChild("Component");
        } catch (e) {
            console.log();
        }
    };
    var spaceFnc = (0,react.useCallback)(function(event) {
        event.preventDefault();
        if (event.target.type === "button") {
            event.target.blur();
        }
        if (event.which === 32 && (exam === null || exam === void 0 ? void 0 : exam.status) === "Đang thi") {
            var st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                isAnswered: true
            });
            dispatch((0,gplx_exam_slice/* setExamSituation */.C_)(st));
        }
    }, [
        examSituation
    ]);
    (0,react.useEffect)(function() {
        if (!(examSituation === null || examSituation === void 0 ? void 0 : examSituation.isAnswered)) {
            document.addEventListener("keydown", spaceFnc, false);
            document.addEventListener("keypress", spaceFnc, false);
        }
        return function() {
            document.removeEventListener("keydown", spaceFnc, false);
            document.removeEventListener("keypress", spaceFnc, false);
        };
    }, [
        spaceFnc,
        examSituation === null || examSituation === void 0 ? void 0 : examSituation.isAnswered
    ]);
    (0,react.useEffect)(function() {
        if (examSituation === null || examSituation === void 0 ? void 0 : examSituation.isAnswered) {
            if ((exam === null || exam === void 0 ? void 0 : exam.status) === "Đang thi") {
                var _situation = examSituation.situation, start = _situation.start, end = _situation.end;
                var player = playerRef.current;
                var currentTime = player.currentTime();
                var duration = player.duration();
                var diff = (end - start) / 5;
                var st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                    seletedTime: currentTime,
                    score: 0
                });
                if (currentTime >= start && currentTime < start + diff) st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                    seletedTime: currentTime,
                    score: 5
                });
                else if (currentTime >= start + diff && currentTime < start + diff * 2) st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                    seletedTime: currentTime,
                    score: 4
                });
                else if (currentTime >= start + diff * 2 && currentTime < start + diff * 3) st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                    seletedTime: currentTime,
                    score: 3
                });
                else if (currentTime >= start + diff * 3 && currentTime < start + diff * 4) st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                    seletedTime: currentTime,
                    score: 2
                });
                else if (currentTime >= start + diff * 4 && currentTime <= end) st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                    seletedTime: currentTime,
                    score: 1
                });
                //update examSituations
                var examSituations = exam.examSituations.filter(function(item) {
                    return item.id !== st.id;
                });
                examSituations.push(st);
                examSituations.sort(function(a, b) {
                    return a.orderNo - b.orderNo;
                });
                dispatch((0,gplx_exam_slice/* setExam */.NI)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, exam), {
                    examSituations: examSituations
                })));
                //save wrong answers situations
                if (st.score == 0) {
                    dispatch((0,gplx_failSituation_slice/* setFailedSituations */.P0)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, st.situation), {
                        score: 0
                    })));
                    dispatch((0,gplx_situation_slice/* addSituationAnswerFailed */.yG)({
                        id: st.situation.id,
                        orderNo: st.situation.orderNo,
                        seletedTime: currentTime,
                        score: 0
                    }));
                }
                drawResultBar(player, currentTime, duration, diff, start, end, st.score);
            }
        } else {
            var player1 = playerRef.current;
            player1.controlBar.removeChild("Button");
            player1.currentTime(0);
            player1.play();
            window.player = player1;
        }
    }, [
        examSituation === null || examSituation === void 0 ? void 0 : examSituation.isAnswered
    ]);
    var drawResultBar = function(player, currentTime, duration, diff, start, end, score) {
        var marginLeftSelect = currentTime / duration * 100;
        var timeWidth = diff / duration * 100;
        var myButton = player.controlBar.addChild("Button", {
            className: "result-bar"
        }, 0);
        // Create our button's DOM Component
        var resultDiv = myButton.el();
        resultDiv.innerHTML = '<div class="result-div"><img style="margin-left:'.concat(marginLeftSelect, '%;height:35px;" src="/icons/flag.png"/>') + '<span class="result-time">'.concat(score, "</span>");
        resultDiv.innerHTML += '<span class="result-answer" style="right:'.concat((duration - start) / duration * 100, '%;">').concat(start, "</span>");
        for(var i = 0; i < 5; i++){
            var color = "red";
            if (i === 0) color = "#008e2c";
            else if (i === 1) color = "#39e500";
            else if (i === 2) color = "#c2e500";
            else if (i === 3) color = "#e56a00";
            else if (i === 4) color = "#e50000";
            var marginLeftStart = (start + diff * i) / duration * 100;
            resultDiv.innerHTML += '<span class="result-answer" style="left:'.concat(marginLeftStart, "%;width:").concat(timeWidth, "%;background-color:").concat(color, '"></span>');
        }
        resultDiv.innerHTML += '<span class="result-answer" style="left:'.concat(end / duration * 100, '%;">').concat(end, "</span>");
        resultDiv.innerHTML += "</div>";
    };
    var drawNavigateBar = function(player) {
        var ref;
        var controlBar = (ref = player.controlBar) === null || ref === void 0 ? void 0 : ref.addChild("Component", {
            className: "my-navigation"
        }, 0);
        // Create our button's DOM Component
        var resultDiv = controlBar.el();
        resultDiv.innerHTML = '<div class="my-navigation-div">' + '<button class="my-button space" onclick="onSpace()">[SPACE]</button>' + "</div>";
        window.onSpace = function() {
            var st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
                isAnswered: true
            });
            dispatch((0,gplx_exam_slice/* setExamSituation */.C_)(st));
        };
    };
    //review video - replay
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        //only play when new video
        if (examSituation && (exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac") {
            var id = examSituation.situation.id;
            player.poster("".concat(config/* BASEURL */.Hc, "/stream/video/").concat(examSituation.situation.id, "/thumbnail/thumb.jpg"));
            player.src({
                src: "".concat(config/* BASEURL */.Hc, "/stream/video/").concat(id, "/index.m3u8"),
                type: "application/x-mpegURL"
            });
            if (examSituation.isAnswered) {
                var _situation = examSituation.situation, start = _situation.start, end = _situation.end;
                var player1 = playerRef.current;
                var currentTime = examSituation.seletedTime;
                var duration = player1.duration();
                var diff = (end - start) / 5;
                player1.controlBar.removeChild("Button");
                drawResultBar(player1, currentTime, duration, diff, start, end, examSituation.score);
            } else {
                var player2 = playerRef.current;
                player2.controlBar.removeChild("Button");
            }
        }
    }, [
        examSituation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        id: "video_1",
        className: "video-js vjs-theme-city",
        playsInline: true
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/sections/situationExam/ExamResultSection.js
/* eslint-disable react/prop-types */ 











function ExamResultSection() {
    var exam = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }).exam;
    var total = exam === null || exam === void 0 ? void 0 : exam.examSituations.map(function(item) {
        return item.score || 0;
    }).reduce(function(a, b) {
        return a + b;
    }, 0);
    var dispatch = (0,es/* useDispatch */.I0)();
    var reset = function() {
        dispatch((0,gplx_exam_slice/* removeExams */.US)(exam));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                alignItems: "center",
                spacing: 0.5,
                sx: {
                    border: 0.1,
                    borderColor: "grey",
                    borderRadius: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "wpf:statistics"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        p: 1,
                        children: " KẾT QUẢ"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                mt: 1,
                p: 1,
                spacing: 1,
                sx: {
                    border: 0.1,
                    borderColor: "grey",
                    borderRadius: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "mdi:question-mark-rhombus-outline"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                px: 1,
                                children: "Số t\xecnh huống:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: [
                                    exam === null || exam === void 0 ? void 0 : exam.examSituations.length,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "material-symbols:check-circle-outline"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                px: 1,
                                children: "Điểm:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: total >= 35 ? "green" : "red",
                                children: [
                                    total,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "ic:sharp-sync-alt"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                px: 1,
                                children: "Trạng th\xe1i:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                color: total >= 35 ? "green" : "red",
                                children: [
                                    exam === null || exam === void 0 ? void 0 : exam.status,
                                    " "
                                ]
                            })
                        ]
                    }),
                    (exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                            total >= 35 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    py: 1.2,
                                    backgroundColor: "#ccffd7"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "solar:smile-circle-linear",
                                        sx: {
                                            color: "green"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "primary",
                                        px: 1,
                                        textAlign: "center",
                                        children: "Đ\xc3 ĐẠT"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    py: 1.2,
                                    backgroundColor: "#ffdcdc"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                        icon: "ri:emotion-sad-line",
                                        sx: {
                                            color: "red"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        color: "error",
                                        px: 1,
                                        textAlign: "center",
                                        children: "Đ\xc3 TRƯỢT"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                spacing: 1,
                                pt: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: reset,
                                        variant: "outlined",
                                        fullWidth: true,
                                        size: "large",
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "ic:outline-sync"
                                        }),
                                        children: "THI LẠI"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/thi-tinh-huong/thi-thu",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            fullWidth: true,
                                            variant: "contained",
                                            size: "large",
                                            children: "ĐỀ KH\xc1C"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                mt: 1,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationItem, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleBannerAds */.D, {})
                ]
            })
        ]
    });
}
function SituationItem() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }), exam = ref.exam, examSituation = ref.examSituation;
    var review = function(item) {
        dispatch((0,gplx_exam_slice/* setExamSituation */.C_)(item));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        component: Paper/* default */.Z,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            size: "medium",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                        sx: {
                            borderWidth: 1,
                            borderColor: "#ccc",
                            borderStyle: "solid"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    px: 0
                                },
                                children: "C\xe2u hỏi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    px: 0
                                },
                                children: "Gắn cờ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    px: 0
                                },
                                colSpan: 2,
                                children: "Điểm "
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                    children: exam === null || exam === void 0 ? void 0 : exam.examSituations.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            sx: {
                                borderWidth: 1,
                                borderColor: "#ccc",
                                borderStyle: "solid"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: [
                                            "C\xe2u  ",
                                            item.orderNo
                                        ]
                                    })
                                }),
                                item.isAnswered ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        sx: {
                                            fontWeight: 500
                                        },
                                        children: [
                                            " ",
                                            Math.round(item.seletedTime * 10) / 10,
                                            "s"
                                        ]
                                    })
                                }) : item.id === (examSituation === null || examSituation === void 0 ? void 0 : examSituation.id) && (exam === null || exam === void 0 ? void 0 : exam.status) === "Đang thi" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Đang l\xe0m"
                                    })
                                }) : item.orderNo <= (examSituation === null || examSituation === void 0 ? void 0 : examSituation.orderNo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "red",
                                        children: "Bỏ qua"
                                    })
                                }) : (exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "red",
                                        children: "Bỏ qua"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0
                                    }
                                }),
                                item.isAnswered ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: item.score
                                    })
                                }) : item.orderNo <= (examSituation === null || examSituation === void 0 ? void 0 : examSituation.orderNo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: "0"
                                    })
                                }) : (exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        children: "0"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    }
                                }),
                                (exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        px: 0,
                                        py: 1.2
                                    },
                                    align: "right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "small",
                                        variant: "text",
                                        sx: {
                                            m: 0,
                                            p: 0
                                        },
                                        onClick: function() {
                                            review(item);
                                        },
                                        children: " Xem lại "
                                    })
                                })
                            ]
                        }, item.id);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/situationExam/VideoExamSection.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ "use client";



















var style = {
    position: "absolute",
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    p: 2,
    margin: 0
};
function VideoExamSection(param) {
    var item = param.item;
    var ref, ref1, ref2;
    var theme = (0,useTheme/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }), exam = ref3.exam, examSituation = ref3.examSituation, hint = ref3.hint;
    var ref4 = (0,react.useState)(true), resultDialog = ref4[0], setResultDialog = ref4[1];
    var translate = (0,useLocales/* default */.Z)().translate;
    var spaceHandle = function() {
        var st = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, examSituation), {
            isAnswered: true
        });
        dispatch((0,gplx_exam_slice/* setExamSituation */.C_)(st));
    };
    var handleCloseHint = function() {
        dispatch((0,gplx_exam_slice/* setHint */.V0)(false));
    };
    var handleOpenHint = function() {
        dispatch((0,gplx_exam_slice/* setHint */.V0)(true));
    };
    var getCurrentSituation = function() {
        return exam === null || exam === void 0 ? void 0 : exam.examSituations.find(function(item) {
            return item.id === (examSituation === null || examSituation === void 0 ? void 0 : examSituation.id);
        });
    };
    var anwserCounter = exam === null || exam === void 0 ? void 0 : exam.examSituations.filter(function(item) {
        return item.isAnswered !== undefined;
    }).length;
    (0,react.useEffect)(function() {
        setResultDialog((exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac" ? true : false);
    }, [
        exam
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        mb: 5,
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 9.5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 1,
                    sx: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamPlayerPreview, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                            disablePortal: true,
                            open: hint,
                            onClose: handleCloseHint,
                            style: {
                                position: "absolute"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: (0,_object_spread/* default */.Z)({}, style),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                                        children: examSituation === null || examSituation === void 0 ? void 0 : examSituation.situation.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AudioPlayer/* default */.Z, {
                                        text: examSituation === null || examSituation === void 0 ? void 0 : examSituation.situation.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: handleCloseHint,
                                        sx: {
                                            px: 5,
                                            float: "right"
                                        },
                                        color: "warning",
                                        variant: "contained",
                                        size: "medium",
                                        children: hint ? "Ẩn gợi \xfd" : "Gợi \xfd"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                            disablePortal: true,
                            open: resultDialog,
                            onClose: function() {
                                return setResultDialog(false);
                            },
                            style: {
                                position: "absolute"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: (0,_object_spread/* default */.Z)({}, style),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultContent, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: function() {
                                            return setResultDialog(false);
                                        },
                                        sx: {
                                            px: 5,
                                            float: "right"
                                        },
                                        color: "warning",
                                        variant: "contained",
                                        size: "medium",
                                        children: "Đ\xf3ng lại"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            textAlign: "center",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            bgcolor: theme.palette.background.neutral,
                            spacing: 5,
                            p: 1,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    flex: 1,
                                    variant: "subtitle1",
                                    children: [
                                        "Đ\xe3 l\xe0m: ",
                                        anwserCounter,
                                        "/",
                                        exam === null || exam === void 0 ? void 0 : exam.examSituations.length
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    flex: 1,
                                    variant: "subtitle1",
                                    children: [
                                        "Điểm: ",
                                        (ref = getCurrentSituation()) === null || ref === void 0 ? void 0 : ref.score,
                                        " (",
                                        ((ref1 = getCurrentSituation()) === null || ref1 === void 0 ? void 0 : ref1.seletedTime) && Math.round(((ref2 = getCurrentSituation()) === null || ref2 === void 0 ? void 0 : ref2.seletedTime) * 10) / 10,
                                        "s)"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: handleOpenHint,
                                    sx: {
                                        px: 5
                                    },
                                    color: "warning",
                                    variant: "contained",
                                    size: "medium",
                                    children: hint ? "Ẩn gợi \xfd" : "Gợi \xfd"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            direction: "row",
                            spacing: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: spaceHandle,
                                fullWidth: true,
                                variant: "contained",
                                size: "large",
                                disabled: (exam === null || exam === void 0 ? void 0 : exam.status) === "Kết th\xfac",
                                children: " SPACE (Ph\xedm c\xe1ch)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Score, {}),
                        exam && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.D, {
                                    title: exam === null || exam === void 0 ? void 0 : exam.metaTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        mb: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h4",
                                            children: translate("button.comment")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "caption",
                                            children: "Ấn SPACE trước khi b\xecnh luận nh\xe9"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentNewForm/* default */.Z, {
                                    itemId: exam.id,
                                    type: "SITUATIONEXAM"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList/* default */.Z, {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 2.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamResultSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleBannerAds */.D, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAds/* GoogleGridAds */.a, {})
            })
        ]
    });
}
function Score() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                children: "PHƯƠNG PH\xc1P CHẤM ĐIỂM"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                children: "B\xe0i thi thử m\xf4 phỏng của bạn sẽ c\xf3 10 t\xecnh huống:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "+ 35 điểm:"
                    }),
                    " tối thiểu để vượt qua b\xe0i thi."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "+ 50 điểm:"
                    }),
                    " tối đa bạn c\xf3 thể đạt được."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                children: "Trong mỗi t\xecnh huống c\xf3 02 mốc thời điểm 5đ v\xe0 0đ:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "+ 5 điểm:"
                    }),
                    " thời điểm bắt đầu c\xf3 dấu hiệu ph\xe1t hiện ra t\xecnh huống nguy hiểm, l\xe1i xe cần xử l\xfd."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "+ 0 điểm:"
                    }),
                    " mốc thời điểm m\xe0 xử l\xfd từ thời điểm n\xe0y vẫn xảy ra tai nạn"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body1",
                children: [
                    " Học vi\xean lựa chọn được giữa 2 mốc n\xe0y sẽ đạt mức điểm tương ứng từ ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "5-4-3-2-1 điểm"
                    }),
                    " (điểm tối đa cho mỗi t\xecnh huống l\xe0 5đ)."
                ]
            })
        ]
    });
}
var ResultContent = function() {
    var exam = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }).exam;
    var total = exam === null || exam === void 0 ? void 0 : exam.examSituations.map(function(item) {
        return item.score || 0;
    }).reduce(function(a, b) {
        return a + b;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                justifyContent: "center",
                alignItems: "center",
                spacing: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                        icon: "wpf:statistics"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        p: 1,
                        children: " KẾT QUẢ B\xc0I THI M\xd4 PHỎNG"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sm: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            m: 1,
                            p: 1,
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "mdi:paper-text-outline"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            px: 1,
                                            children: "Đề thi:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: [
                                                "Đề số ",
                                                exam === null || exam === void 0 ? void 0 : exam.orderNo,
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "mdi:question-mark-rhombus-outline"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            px: 1,
                                            children: "Số t\xecnh huống:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: [
                                                exam === null || exam === void 0 ? void 0 : exam.examSituations.length,
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "material-symbols:check-circle-outline"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            px: 1,
                                            children: "Điểm:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: total >= 35 ? "green" : "red",
                                            children: [
                                                total,
                                                "/50"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "mdi:web-cancel"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            px: 1,
                                            children: "Tại:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            children: "onthibanglaixe.net"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sm: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            alignItems: "center",
                            justifyItems: "center",
                            m: 2,
                            p: 1,
                            spacing: 1,
                            sx: {
                                border: 0.1,
                                borderColor: "grey.400",
                                borderRadius: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle1",
                                    children: " KẾT QUẢ"
                                }),
                                total >= 35 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "healthicons:award-trophy",
                                            sx: {
                                                color: "green",
                                                fontSize: 40
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "primary",
                                            px: 1,
                                            textAlign: "center",
                                            children: "Đ\xc3 ĐẠT"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "ri:emotion-sad-line",
                                            sx: {
                                                color: "red",
                                                fontSize: 40
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            color: "error",
                                            px: 1,
                                            textAlign: "center",
                                            children: "Đ\xc3 TRƯỢT"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                component: Paper/* default */.Z,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                    size: "small",
                    border: 1,
                    style: {
                        border: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            fontWeight: 500
                                        },
                                        children: "C\xe2u hỏi"
                                    }),
                                    exam === null || exam === void 0 ? void 0 : exam.examSituations.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            children: item.orderNo
                                        }, item.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            fontWeight: 500
                                        },
                                        children: "Điểm"
                                    }),
                                    exam === null || exam === void 0 ? void 0 : exam.examSituations.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                color: item.score > 0 ? "auto" : "red"
                                            },
                                            children: item.isAnswered ? item.score : 0
                                        }, item.id);
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSection/* AppDownload */.B, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.D, {
                title: exam === null || exam === void 0 ? void 0 : exam.metaTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    mb: 1
                }
            })
        ]
    });
};
/* harmony default export */ var situationExam_VideoExamSection = (VideoExamSection);

;// CONCATENATED MODULE: ./src/pages/thi-tinh-huong/thi-thu/[slug].js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 















var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
SituationExam.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function SituationExam(param) {
    var exam = param.exam;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var dispatch = (0,es/* useDispatch */.I0)();
    var reset = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }).reset;
    var translate = (0,useLocales/* default */.Z)().translate;
    (0,react.useEffect)(function() {
        dispatch((0,gplx_exam_slice/* setExam */.NI)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, exam), {
            status: "Đang thi"
        })));
        dispatch((0,gplx_exam_slice/* setExamSituation */.C_)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, exam.examSituations[0]), {
            isAnswered: false
        })));
        dispatch((0,gplx_exam_slice/* setHint */.V0)(false));
    }, [
        exam.orderNo,
        reset
    ]);
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    (0,react.useEffect)(function() {
        dispatch((0,blog_comment/* setCommentSearch */.VG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchComment), {
            value: "",
            page: 0,
            filterBys: {
                itemId: exam.id,
                type: "SITUATIONEXAM"
            }
        })));
    }, [
        exam
    ]);
    var breadcrumbLinks = [
        {
            name: translate("menu.home"),
            href: paths/* PATH_THIGPLX.home */.sH.home
        },
        {
            name: translate("menu.situation"),
            href: paths/* PATH_THIGPLX.situations */.sH.situations
        },
        {
            name: translate("situationExam.title"),
            href: "/thi-tinh-huong/thi-thu"
        },
        {
            name: "Đề thi số ".concat(exam.orderNo)
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: exam.metaTitle,
        description: exam.metaDescription,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: themeStretch ? "xl" : "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        my: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBreadcrumbs/* default */.Z, {
                            heading: "Đề thi số ".concat(exam.orderNo),
                            links: breadcrumbLinks,
                            subtitle: "Quay lại chọn đề thi m\xf4 phỏng kh\xe1c"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        my: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(situationExam_VideoExamSection, {
                                item: exam
                            })
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 16634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10633);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77251);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33599);
/* harmony import */ var _CommentItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83741);
/* eslint-disable react-hooks/exhaustive-deps */ 



// @mui







// ----------------------------------------------------------------------
function CommentList() {
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), comments = ref.comments, totalPages = ref.totalPages, isLoading = ref.isLoading, search = ref.search, numberOfElements = ref.numberOfElements;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), sortBy = ref1[0], setSortBy = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .getComments */ .li)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search
    ]);
    var handleChangePage = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: value - 1
        })));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "likeNo"
            }
        ];
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            orders: orders
        })));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: [
                            translate("label.sortBy"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "standard",
                        value: sortBy,
                        size: "small",
                        sx: {
                            fontSize: 12,
                            fontWeight: "bold",
                            ml: 1,
                            pt: 1
                        },
                        disableUnderline: true,
                        onChange: handleChangeSort,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "0",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByNew")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "1",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByOld")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "2",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByLike")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                spacing: 2,
                children: [
                    comments.map(function(comment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentItem__WEBPACK_IMPORTED_MODULE_7__/* .CommentItemWrapper */ .w, {
                            comment: comment
                        }, comment.id);
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonCommentItem */ .bG, {}) : numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: " ",
                        description: translate("label.noComment")
                    })
                ]
            }),
            numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2544,5101,1160,3362,917,2077,5410,6461,1739,892,4538,1876,1284,4411,3559,4397,2225,9774,2888,179], function() { return __webpack_exec__(16167); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);